const getters = {
  sidebar: state => state.app.sidebar,
  device: state => state.app.device,
  pathname: state => state.app.pathname,
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  name: state => state.user.userName,
  hospitalName: state => state.user.hospitalName,
  hospitalCode: state => state.user.hospitalCode,
  tags: state => state.user.tags,
  iszzYTH: state => state.user.iszzYTH,
  userInfo: state => state.user.userInfo,
  patientInfo: state => state.patient.patientInfo,
  // onlineUser: state => state.onlineUser.onlineUser
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js